import { HandleableError } from "@context-providers/error-handler/error-handler-types";
import {
  getErrorDisplayMarkup,
  isErrorFromBackend,
} from "@context-providers/error-handler/error-handler-utils";
import { NO_TRANSLATE_CLASS } from "@flat-ui";
import { SanitizedHtmlTag } from "@context-providers/error-handler/sanitized-html-tag";
import { Box } from "@mui-wrapper";

interface Props {
  /** The error whose human-readable detail should be displayed */
  error: HandleableError;
}

/**
 * Renders the human-readable detail of an error.
 * Backend errors can embed user data (names, emails, etc.), so they are excluded
 * from LocalizeJS translation. Dashboard-thrown errors are static, translatable strings.
 */
export function ErrorDetailMessage({ error }: Props): JSX.Element {
  const markup = getErrorDisplayMarkup(error);

  if (isErrorFromBackend(error)) {
    return (
      <Box component="div" className={NO_TRANSLATE_CLASS}>
        <SanitizedHtmlTag markup={markup} />
      </Box>
    );
  }

  return <SanitizedHtmlTag markup={markup} />;
}
